import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const root = ({ colorsV2 }: ExactTheme) =>
  css({
    display: "grid",
    gridTemplateColumns: "155px 1fr",
    gap: 1,
    padding: 1,
    backgroundColor: colorsV2.grey[100],
    borderRadius: 6,
  });

export const header =
  ({ position }: { position: "start" | "end" | "middle" }) =>
  ({ fontWeights }: ExactTheme) =>
    css({
      fontWeight: fontWeights.medium,
      padding: 10,
      backgroundColor: "#fff",
      borderTopLeftRadius: position === "start" ? "6px" : 0,
      borderTopRightRadius: position === "end" ? "6px" : 0,
    });

export const cell = ({ colorsV2 }: ExactTheme) =>
  css({
    padding: "14px 10px",
    backgroundColor: colorsV2.grey[25],
  });
